<template lang="pug">
NuxtLayout
    Html(translate='no')
    UApp
        NuxtLoadingIndicator
        NuxtPage
</template>
<script setup lang="ts">
import { onMessage } from "firebase/messaging";

//provideHeadlessUseId(() => useId());
// useHead({
//     script: [
//         { src: '/newrelic.js', defer: true }
//     ]
// });
const { $fcm } = useNuxtApp();
const toast = useToast();
onMounted(() => {
  onMessage($fcm.messaging, (payload) => {
    $fcm.store.messages.unshift(payload);
    toast.add({
      title: payload.notification?.title,
      description: payload.notification?.body,
    });
    // if (process.env.NODE_ENV === "development") {
    //   console.log("Message received on app:. ", payload);
    // }
  });
});
</script>
